import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

interface Props {
  style?: React.CSSProperties;
}

export default function Spinner(props: Props): JSX.Element {
  return <LoadingOutlined spin {...props} />;
}
